/**
 * Utility function to avoid double awaits in components.
 * @param input
 * @param init
 */
export const fetcher = async (input: RequestInfo, init: RequestInit): Promise<any> => {
  const res = await fetch(input, init);
  return res.json();
};
